import ApiService from '@/services/core/api.service'

const AdminDiscountService = {
  async get (query) {
    return ApiService.get(`admin/discounts?${query}`)
  }
}

export default AdminDiscountService
